import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useInView } from '../hooks/useInView';
interface PromiseAndCtaSectionProps {
  onAddToCart?: () => void;
}
export function PromiseAndCtaSection({
  onAddToCart
}: PromiseAndCtaSectionProps) {
  const {
    ref,
    isVisible
  } = useInView();
  const handleClick = () => {
    onAddToCart?.();
  };
  return <section id="offer" ref={ref} className="w-full bg-navy py-12 px-6 md:py-20 text-center" data-id="element-192">
      <div className={`max-w-2xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-193">
        {/* Promise */}
        <div className="mb-10" data-id="element-194">
          <h2 className="font-serif text-3xl md:text-4xl text-gold mb-6" data-id="element-195">
            La promesa realista
          </h2>
          <div className="font-sans text-lg md:text-xl text-white/90 leading-relaxed space-y-3" data-id="element-196">
            <p data-id="element-197">No te prometo una vida perfecta.</p>
            <p data-id="element-198">Te prometo algo más útil:</p>
            <p className="font-serif text-2xl md:text-3xl text-white italic py-2" data-id="element-199">
              Una estructura clara para manejar el diálogo interno del día a día
              con menos desgaste mental.
            </p>
          </div>
        </div>

        {/* Final CTA */}
        <div className="p-6 md:p-8 rounded-2xl border border-gold/30 bg-white/5" data-id="element-200">
          <p className="font-serif text-xl text-white mb-6" data-id="element-201">
            Si hoy estás cansada de ser tu propia jueza, en 14 días puedes estar
            viviendo tus días con más orden mental. Empieza hoy.
          </p>

          {/* Price above button */}
          <p className="font-serif text-3xl md:text-4xl text-gold font-bold mb-4" data-id="element-202">
            $6.39
          </p>

          <a href="https://narelaspace.com/cart/47546656194780:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="w-full md:w-auto bg-gold hover:bg-gold/90 text-navy font-bold py-5 px-10 rounded-lg shadow-[0_0_30px_rgba(201,168,76,0.4)] transition-all hover:scale-[1.02] flex items-center justify-center gap-3 text-xl mx-auto no-underline" data-id="element-203">
            Descargar la guía ahora
            <ArrowRight className="w-6 h-6" data-id="element-204" />
          </a>

          <div className="mt-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-white/60 text-sm font-sans" data-id="element-205">
            <span data-id="element-206">Descarga inmediata</span>
            <span className="hidden md:inline" data-id="element-207">·</span>
            <span data-id="element-208">14 días</span>
            <span className="hidden md:inline" data-id="element-209">·</span>
            <span data-id="element-210">10 min al día</span>
          </div>
        </div>
      </div>
    </section>;
}